import { Button } from "@pankod/refine-antd";
import { IResourceComponentsProps } from "@pankod/refine-core";
import React, { useCallback, useState } from "react";
import CSVReader from "react-csv-reader";
import { message } from "antd";
import { IMPORT_STATUS } from "constants/types";
// import { io } from "socket.io-client";
import { importTracks } from "apis/import";

export const Tracks: React.FC<IResourceComponentsProps> = () => {
  const [data, setData] = useState<any>(null);
  const [isLoading, setLoading] = useState<boolean>(false);
  // const socket = io(process.env.REACT_APP_HOST_API || "http://localhost:5001");

  // useEffect(() => {
  //   socket.on("importTrackAdmin", (data) => {
  //     if (data?.type === IMPORT_STATUS.SUCCESS) {
  //       message.success(data?.message || "Import tracks successfully.");
  //       setLoading(false);
  //     } else if (data?.type === IMPORT_STATUS.WARNING) {
  //       setLoading(false);
  //       message.warning(
  //         `Warning : ${
  //           (data?.existedTracks || []).length
  //         } tracks have already exist `,
  //         10
  //       );
  //       setLoading(false);
  //     } else {
  //       message.error("Something went wrong.");
  //     }
  //     setLoading(false);
  //   });
  //   // return () => {
  //   //   socket.off("importTrackAdmin");
  //   // };
  // }, [socket]);

  // const handleImportSocket = useCallback(async () => {
  //   setLoading(true);
  //   socket.emit("importTrackAdmin", {
  //     data,
  //     clientId: socket.id,
  //   });
  // }, [data, socket]);

  const handleImport = useCallback(async () => {
    setLoading(true);
    const res = await importTracks(data);
    if (res?.type === IMPORT_STATUS.SUCCESS) {
      message.success(res?.message || "Import tracks successfully.");
      setLoading(false);
    } else if (res?.type === IMPORT_STATUS.WARNING) {
      setLoading(false);
      message.warning(
        `Warning : ${
          (res?.existedTracks || []).length
        } tracks have already exist `,
        10
      );
      setLoading(false);
    } else {
      //   message.error("Something went wrong.");
    }
    // setLoading(false);
  }, [data]);

  return (
    <div style={{ marginTop: "40px" }}>
      <CSVReader
        onFileLoaded={async (data, fileInfo, originalFile) => {
          const cols = data[0];
          let objectData: any[] = [];
          data.slice(1).forEach((item) => {
            let obj: any = {};
            cols.forEach((col: any, index: any) => {
              obj[col] = item[index];
            });
            objectData.push(obj);
          });
          setData(objectData);
        }}
      />
      {data && (
        <Button
          style={{ marginTop: "40px" }}
          loading={isLoading}
          onClick={handleImport}
          disabled={isLoading}
        >
          Import
        </Button>
      )}
    </div>
  );
};
